import { render, staticRenderFns } from "./MemberNews.vue?vue&type=template&id=4939ef84"
import script from "./MemberNews.vue?vue&type=script&lang=js"
export * from "./MemberNews.vue?vue&type=script&lang=js"
import style0 from "./MemberNews.vue?vue&type=style&index=0&id=4939ef84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports